<template>
<div>
  <game-title-layout :show-top="showTop"></game-title-layout>
  <div class="gameImgArea">
    <div class="box"  v-for="(item, index) in mapList" :key="index" :id="getLinesId(index)">
      <img :src="require('../../assets/wlzb/' + (((item == 'wild') && (wildType != '0')) ? (item + wildType) : item)  + '.png')" :title="((item == 'wild') && (wildType != '0')) ? ('x' + wildMul) : ''" :class="{ deep: matchDeepColor(index) }">
    </div>
  </div>
  <div class="gameImgDetail">
    <div class="box" v-for="(item, index) in mapListDetail" :key="index">
      <img :src="require('../../assets/wlzb/' + item.key + '.png')" alt="" :class="{ deep: true }">
      <p> x {{item.lines}} ({{item.length}})</p>
      <p v-if="item.winInfo !=null">{{item.winInfo}}</p>
    </div>
  </div>
  <SlotsWinTotalLayout :show-total="showTotal" :win-value-total="winValueTotal"></SlotsWinTotalLayout>
</div>
</template>

<script>
import GameTitleLayout from "../common/game_detail_title.vue";
import SlotsWinTotalLayout from "./layout/slots_win_total_layout.vue";
import {slots_tool} from "./slots_tool";

export default {
  name: "Game305",
  components: {
    SlotsWinTotalLayout,
    GameTitleLayout

  },
  props: {
    showTop: false,
    showTotal:false,
    winValueTotal:null,
    wildType: '',
    wildMul: '',
    linesId:"0",
    mapList: [],
    mapListDetail: [],
    mapIndex: [],
    Phone:false,
  },
  methods: {
    matchDeepColor(index)
    {
      return slots_tool.matchDeepColor(this.mapIndex,index);
    },
    getLinesId(index) {
      return slots_tool.setLineIdName(this.linesId, index)
    },
  }
}
</script>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/slots/game_305.vue